import { render, staticRenderFns } from "./weekKPI.vue?vue&type=template&id=5f42c837&scoped=true"
import script from "./weekKPI.vue?vue&type=script&lang=js"
export * from "./weekKPI.vue?vue&type=script&lang=js"
import style0 from "./weekKPI.vue?vue&type=style&index=0&id=5f42c837&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f42c837",
  null
  
)

export default component.exports